/**
 * @param {*} filePath
 * @param {*} fileUrl
 * @returns {ToothStageRawDO | null}
 */

import {
  getRawDataFromIPRRaw,
  getRawDataFromVisibilityRaw,
} from "../convert/rawConver";

const rawConvertMap = {
  VISIBILITY: getRawDataFromVisibilityRaw,
  IPR: getRawDataFromIPRRaw,
};

const convertByRawType = (rawType, fileUrl) => {
  if (!rawConvertMap[rawType]) {
    throw new Error(`rawType ${rawType} not found`);
  }
  return rawConvertMap[rawType](fileUrl);
};

export const getToothStageRawDOFromFilePath = async (filePath, fileUrl) => {
  const regex = /.*_STAGE_(\d+).*__(LOWER|UPPER)__(VISIBILITY|IPR).raw$/i;
  const match = filePath.match(regex);
  if (match) {
    const stageNumber = parseInt(match[1], 10);
    const toothGumType = match[2];
    const rawType = match[3];
    const rawData = await convertByRawType(rawType, fileUrl);

    return {
      stageNumber,
      toothGumType,
      rawType,
      rawData,
      fileUrl,
      filePath,
    };
  }
  return null;
};
